import React, { useState } from 'react';
import { supabase } from '../../../supabase';   

const Admin = () => {
  const [formData, setFormData] = useState({
    name: '', 
    email: '',
    password: '',
 
    plan: 'partner'
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Nome é obrigatório';
    }

  
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email é inválido';
    }

    if (!formData.password) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }
 

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    
    try {
      // TODO: Replace with actual API call
      console.log('Creating user:', formData);
      
      // Create user with Supabase
      const { data, error } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        
        
      });
      
      

      if (error) {
        console.error('Supabase error details:', error);
        console.error('Error message:', error.message);
        console.error('Error code:', error.status);
        console.error('Error details:', error.details);
        throw error;
      }

      console.log('User created successfully:', data);
      alert('Usuário criado com sucesso!');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        password: '', 
        plan: 'partner'
      });
      
    } catch (error) {
      console.error('Error creating user:', error);
      alert('Error creating user. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <h1>Add New User</h1>
      
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>
          <label htmlFor="name" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Nome *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '10px',
              border: `1px solid ${errors.name ? '#ff6b6b' : '#ddd'}`,
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Digite o nome"
          />
          {errors.name && (
            <span style={{ color: '#ff6b6b', fontSize: '14px', marginTop: '5px', display: 'block' }}>
              {errors.name}
            </span>
          )}
        </div>

 

        <div>
          <label htmlFor="email" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Email *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '10px',
              border: `1px solid ${errors.email ? '#ff6b6b' : '#ddd'}`,
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter email address"
          />
          {errors.email && (
            <span style={{ color: '#ff6b6b', fontSize: '14px', marginTop: '5px', display: 'block' }}>
              {errors.email}
            </span>
          )}
        </div>

        <div>
          <label htmlFor="password" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Password *
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '10px',
              border: `1px solid ${errors.password ? '#ff6b6b' : '#ddd'}`,
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter password (min 6 characters)"
          />
          {errors.password && (
            <span style={{ color: '#ff6b6b', fontSize: '14px', marginTop: '5px', display: 'block' }}>
              {errors.password}
            </span>
          )}
        </div>

         
        <div>
          <label htmlFor="plan" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Plano
          </label>
          <select
            id="plan"
            name="plan"
            value={formData.plan}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="partner">Partner</option>
            <option value="lead">Lead</option>
            <option value="enterprise">Enterprise</option>
        
          </select>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            padding: '12px 20px',
            backgroundColor: isSubmitting ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
            marginTop: '10px'
          }}
        >
          {isSubmitting ? 'Criando Usuário...' : 'Criar Usuário'}
        </button>
      </form>
    </div>
  );
};

export default Admin;